// extracted by mini-css-extract-plugin
export var markdown = "MarkdownContent-module--markdown--NhNtm";